export { default as Img200 } from './processed/200/PatriotGames.jpg';
export { default as Img400 } from './processed/400/PatriotGames.jpg';
export { default as Imgthumb } from './processed/thumb/PatriotGames.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/PatriotGames.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/PatriotGames.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      220,
      4,
      36
    ],
    "_population": 3587,
    "_hsl": [
      0.9753086419753086,
      0.9642857142857144,
      0.4392156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      161,
      10,
      43
    ],
    "_population": 406,
    "_hsl": [
      0.9635761589403974,
      0.8830409356725147,
      0.3352941176470588
    ]
  },
  "Muted": {
    "_rgb": [
      108,
      116,
      148
    ],
    "_population": 1,
    "_hsl": [
      0.6333333333333334,
      0.15748031496063,
      0.5019607843137255
    ]
  },
  "LightMuted": {
    "_rgb": [
      190,
      189,
      186
    ],
    "_population": 593,
    "_hsl": [
      0.1250000000000003,
      0.02985074626865682,
      0.7372549019607844
    ]
  },
  "DarkMuted": {
    "_rgb": [
      67,
      70,
      102
    ],
    "_population": 1852,
    "_hsl": [
      0.6523809523809524,
      0.20710059171597633,
      0.3313725490196079
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/PatriotGames.js